import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import fetchHelpers from '../../helpers/fetchHelpers';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_ZarCn1rkQuXQ91XY6KD51bo7');

const Stripe = () => {
  const handleClick = async (event) => {
    // Get Stripe.js instance
    const stripe = await stripePromise;

    // Call your backend to create the Checkout Session
    const response = await fetchHelpers.postToCreateCheckoutSession(5);

    // const response = await fetch('http://localhost:10295/stripe/CreateCheckoutSession?courseid=5', { method: 'POST' });

    const session = await response.json();

    console.log('session', session);

    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    }


    // const session = await response.json();


  };
  return (
    <button role="link" onClick={handleClick}>
      Checkout
    </button>
  );
};

export default Stripe;



// WEBPACK FOOTER //
// ./src/views/Main/Stripe.js